import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { fontFamily } from '~/constants/text';
import Slot from '~/components/BookingTimeSelector/Views/components/SlotStates';
import { colors } from '~/constants/colors';

export const TODAY = 'TODAY';
export const TOMORROW = 'TOMORROW';

const ClosedSlotContainer = styled.div.withConfig({ componentId: 'sc-2cvanc-0' })`
  position: relative;
  background-color: ${colors.fatherJohnMisty};
  color: ${colors.greyWorm};
  letter-spacing: -0.17px;
  line-height: 15px;
  text-align: center;
  padding: 8px;
  white-space: nowrap;
  font-size: 14px;
  font-family: ${fontFamily.medium};
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  flex-shrink: 0;
  width: 64px;
  margin: 0 8px 0 0;
`;
export const ClosedSlotSRP = ({ className }: { className?: string }) => {
  const { t } = useTranslation('bookingWidget');
  return (
    <ClosedSlotContainer className={className}>
      {t('openClosedStatusText.closed')}
    </ClosedSlotContainer>
  );
};

const NoAvailableContainer = styled.div.withConfig({ componentId: 'sc-2cvanc-1' })`
  position: relative;
  background-color: ${colors.fatherJohnMisty};
  color: ${colors.greyWorm};
  letter-spacing: -0.17px;
  line-height: 15px;
  text-align: center;
  padding: 8px 0;
  border: 1px solid ${colors.fatherJohnMisty};
  width: 162px;
  font-size: 14px;
  font-family: ${fontFamily.medium};
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  margin: 0 8px 0 0;
`;
export const NoAvailableSRP = ({ className }: { className?: string }) => {
  const { t } = useTranslation();
  return (
    <NoAvailableContainer className={className}>
      {t('bookingTimeSelector.noTimesAvailable')}
    </NoAvailableContainer>
  );
};

export const SlotSRP = styled(Slot).withConfig({ componentId: 'sc-2cvanc-2' })`
  background-color: ${colors.crunchBerryXLight};
  color: ${colors.crunchBerryDark};
  border: unset;
  font-size: 14px;
  font-family: ${fontFamily.medium};
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  flex-shrink: 0;
  width: 80px;
  margin: 0 8px 8px 0;
`;
export const DayLabelSRP = styled.div.withConfig({ componentId: 'sc-2cvanc-3' })`
  margin-bottom: 8px;
  display: flex;
  height: 20px;
  color: ${colors.darkSquid};
  font-family: ${fontFamily.medium};
  font-size: 10px;
  line-height: 21px;
  -webkit-font-smoothing: antialiased;
`;
